/*
=========================================================
* Material Kit 2 React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components

// Material Kit 2 React components
// Material Kit 2 React components
import DefaultFlagCard from "views/Cards/FlagCards/DefaultFlagCard";
import Grid2 from "@mui/material/Unstable_Grid2";
import { CountryFlags } from "../../../store/constant/constant";

function Countries() {
  return (
    <Grid2 container my={2}>
      {CountryFlags.map(({ Country, FlagUrl }) => (
        <Grid2 container xs={12} sm={12} md={6} lg={3} key={Country}>
          <DefaultFlagCard image={FlagUrl} title={Country} key={Country} />
        </Grid2>
      ))}
    </Grid2>
  );
}

export default Countries;
